import { EventEmitter } from "@angular/core";

export class ScriptMetaData {

    public name: string;

    public source: string;

    public isAsync: boolean;

    public isDefer: boolean;

    public onScriptLoaded: EventEmitter<Event>;
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/dataModels/script-meta-data.ts